var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7m-2 11V8l5.5 4zm10.3 3.3-1.4-1.4c1.3-1.6 2.2-3.6 2.2-5.8s-.8-4.3-2.2-5.8l1.4-1.4C22 6.7 23 9.2 23 12s-1 5.3-2.7 7.3M5.2 17.8l-1.4 1.4C2 17.3 1 14.8 1 12s1-5.3 2.7-7.3l1.4 1.4C3.8 7.7 3 9.8 3 12s.8 4.3 2.2 5.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.82234d66783811a9203ff382e3562f73.svg";
export { ForwardRef as ReactComponent };